import(/* webpackMode: "eager" */ "/private/tmp/rf-gpw-ebi-recovery-build-20261012/src/app/global-error.tsx");
